export default __webpack_public_path__ + "static/media/size_chart.5e73abe7.jpeg";